<template>
    <v-alert
        v-if="showAlert"
        prominent
        dismissible
        border="top"
        dark
        color="secondary"
        icon="mdi-clipboard-clock"
    >
        <span v-html="alertMessage"></span>
        <v-progress-linear
            v-if="inProcess"
            class="my-2 mr-4"
            height="20"
            rounded
            indeterminate
            color="secondary darken-2"
        ></v-progress-linear>
    </v-alert>
</template>

<script>
export default {
    name: "student-alert",
    props: {
        student: {
            type: Object,
            required: true,
        },
        screen: {
            type: Object,
            required: true,
        },
    },
    computed: {
        startReportMessage() {
            return this.student.id === this.authUser.id
                ? "Please start your tenant sample report check to generate your report"
                : `Please start the tenant sample report on behalf of <strong>${this.student.name}</strong>`;
        },
        progressReportMessage() {
            return this.student.id === this.authUser.id
                ? "Your tenant sample report is in process. It may take a few minutes ..."
                : `The tenant sample report for ${this.student.name} is in process. It may take a few minutes ...`;
        },
        alertMessage() {
            let message = "";
            if (!this.hasScreen && !this.inProcess) {
                message = this.startReportMessage;
            } else if (this.inProcess) {
                message = this.progressReportMessage;
            }
            return message;
        },
        inProcess() {
            return Object.keys(this.screen).length > 0
                ? this.$_.get(this.screen, "status.status", "") ===
                      "SCREEN_IN_PROCESS"
                : false;
        },
        hasScreen() {
            return Object.keys(this.screen).length > 0
                ? this.$_.get(this.screen, "status.status") ===
                      "SCREEN_COMPLETED"
                : false;
        },
        showAlert() {
            return this.inProcess || !this.hasScreen;
        },
    },
};
</script>

<style lang="scss" scoped>
</style>